export default class webglTopBack{
    constructor(kv){

        this.kv = kv;

        //dom
        this.sns = document.getElementById('c-sns');

    }

    /* ---------------------------------------------------

　　　-- 一覧からTOPに戻る

    --------------------------------------------------- */

    set(){

        TweenMax.set(this.kv.man, {
            opacity: 1,
            display:'block'
        });

        TweenMax.to(this.kv.back, 0.6, {
            opacity: 0,
            display: 'none',
            scale:0.8,
            ease: Sine.easeOut,
            onComplete:() => {
                TweenMax.fromTo([this.kv.content, this.kv.btn], 1.2, {
                    rotation:175,
                },{
                    delay:0.8,
                    display: 'block',
                    opacity: 1,
                    scale: 1,
                    rotation: 0,
                    ease: Sine.easeInOut
                });
                TweenMax.to([this.kv.headerTitle,this.kv.headerContact,this.kv.headerBtn], 0.6, {
                    delay:0.6,
                    display: 'block',
                    opacity: 1,
                    scale: 1,
                    ease: Sine.easeOut
                });
                TweenMax.staggerTo(this.sns.children, 1.2 , {
                    x : 0,
                    ease : Back.easeOut.config(1)
                },0.1);
                TweenMax.fromTo(this.kv.scrolldown, 0.6, {
                    opacity:0,
                    scale:0.8,
                },{
                    opacity: 1,
                    scale:1,
                    ease: Back.easeOut.config(1),
                });
                if(Useragnt.mobile || Useragnt.tablet) {
                    TweenMax.to(this.kv.informationBtn, 0.3, {
                        delay:1.8,
                        opacity: 1,
                        display: 'block',
                        scale: 1,
                        ease: this.kv.easeBack
                    });
                }
            }
        });

        if(Useragnt.mobile || Useragnt.tablet) {
            TweenMax.to(this.kv.pager,0.6, {
                delay:1,
                display: 'none',
                opacity: 0,
                scale: 0.8,
                ease: this.kv.easeBack,
            });
            if(this.kv.shuffleRepeat) {
                this.kv.shuffleRepeat.pause();
            }
            TweenMax.to(this.kv.shuffle,0.6, {
                display: 'none',
                opacity: 0,
                ease: this.kv.easeBack,
            });
        }

        window.mv_main.topFromList({
            onComplete:() => {
                document.querySelector('html').classList.remove('is-full');
            }
        });

    }


}